// hooks/useFingerprint.ts

'use client';

import { useCallback, useEffect } from 'react';

import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react';

import { sendFingerprintToBackend } from '@/utils/fingerprint';
import { isFingerprintCaptured, setFingerprintCaptured } from '@/utils/fingerprintStorage';

import { useAuth } from '@/core/auth/client/AuthProvider';

export const useFingerprint = () => {
  const { getData } = useVisitorData({ ignoreCache: false }, { immediate: false });
  const { session } = useAuth();

  const captureFingerprint = useCallback(async () => {
    if (!session?.user?.id || isFingerprintCaptured()) return;

    try {
      const data = await getData({ linkedId: session.user.id });
      if (data?.visitorId) {
        await sendFingerprintToBackend(data.visitorId);
        setFingerprintCaptured();
      }
    } catch (error) {
      console.warn('Fingerprint capture failed:', error);
    }
  }, [session?.user?.id, getData]);

  useEffect(() => {
    if (!session?.user?.id || isFingerprintCaptured()) return;

    const timer = setTimeout(captureFingerprint, 1000);
    // eslint-disable-next-line consistent-return
    return () => { return clearTimeout(timer); };
  }, [captureFingerprint, session?.user?.id]);

  return { captureFingerprint };
};
